// ─────────────────────────────────────────────────────────────────────────────
// AnalyticsHeader.js — the dark strip at the top of the page shell: title,
// subtitle and the Export button.
//
// ⚠ Export is UI only — the button has no handler yet. It is the one unwired
//   control on this page.
// ─────────────────────────────────────────────────────────────────────────────
import { ReactComponent as AnalyticsIcon } from "../../../assets/icons/analytics.svg";
import { ReactComponent as ExportIcon }    from "../../../assets/icons/export.svg";
import styles from "./AnalyticsHeader.module.css";

export default function AnalyticsHeader() {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <div className={styles.titleIcon}>
          <AnalyticsIcon width="20" height="20" />
        </div>
        <div className={styles.titleText}>
          <h2 className={styles.name}>Platform Analytics</h2>
          <p className={styles.sub}>Deep insights into network performance and risk trends</p>
        </div>
      </div>

      <button type="button" className={styles.exportBtn}>
        <ExportIcon width="14" height="14" />
        Export
      </button>
    </div>
  );
}
